function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconErrorService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 88 74"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M43.14 1.446a1 1 0 0 1 1.719 0L87.1 72.489A1 1 0 0 1 86.242 74H1.758A1 1 0 0 1 .9 72.489z",
  "data-name": "Polygon 1",
  style: {
    fill: "#c4c4c4"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "!"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 3",
  style: {
    fill: "#fff"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.444 20.29H.514l-.024-.475L-.5.025-.525-.5h5.01l-.027.525-.357 7.15-.632 12.64z",
  style: {
    stroke: "none"
  },
  transform: "translate(41.966 30.496)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 .99 19.79h1.979L3.959 0zm-1.051-1h6.06L3.92 20.79H.04L-1.052-1z",
  style: {
    fill: "#fff",
    stroke: "none"
  },
  transform: "translate(41.966 30.496)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 2",
  style: {
    stroke: "#fff",
    fill: "#fff"
  },
  transform: "translate(42 55)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  stroke: "none",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2.5,
  style: {
    fill: "none"
  }
}))));
export default SvgIconErrorService;